import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getHeadErrorOrEmptyObj } from 'src/utils/form'
import styled from 'styled-components'

const StyledInputContainer = styled.div`
  margin: 10px 0;

  label {
    box-sizing: border-box;
    font-size: 12px;
    font-weight: 500;
    line-height: 13px;
    z-index: 1;
    padding: 0;
    background-color: transparent;
  }
`

const StyledInput = styled.input`
  width: 100%;
  height: 50px;
  padding: 16px;
  border: ${props => (props.hasError ? '1px solid #db002f' : '1px solid #D1D5DB')};
  background: ${props => !props.value || props.value.length === 0 ? ( props.hasError ? props.theme.palette.common.red50 : props.theme.palette.common.gray50) : 'unset'};
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  box-sizing: border-box;
  margin-top: 8px;

  &:focus {
    outline: none;
    border-color: #db002f;
    box-shadow: 0 0 0 1px #db002f;
  }

  &::placeholder {
    color: ${props => (props.hasError ? props.theme.palette.common.red500 : props.theme.palette.common.gray500)};
  }
`

const ErrorText = styled.div`
  color: #db002f;
  font-size: 12px;
  margin-top: 4px;
`

export const ContactFormInput = props => {
  const {
    name,
    onChange,
    validate,
    label,
    value: initialValue,
    required,
    disabled,
    reset
  } = props
  const [touched, _setTouched] = useState(false)
  const [value, _setValue] = useState(initialValue || '')
  const [{ valid, error }, _validate] = useState({
    valid: true,
    error: {}
  })

  const { t } = useTranslation()

  useEffect(() => {
    if (touched && !reset) {
      validate(name, v => {
        _validate({ valid: v.valid, error: getHeadErrorOrEmptyObj(v) })
      })
    }
  }, [value, touched, reset])

  useEffect(() => {
    _setValue(initialValue)
  }, [initialValue])

  useEffect(() => {
    if (reset) {
      _setValue(initialValue || '')
    }
  }, [reset])

  const handleFocus = () => _setTouched(true)
  const handleChange = e => {
    _setValue(e.target.value)
    onChange(name, e.target.value)
  }

  return (
    <StyledInputContainer>
      <div>
        {label && (
            <label htmlFor={name}>
            {label}
            {required && <span> *</span>}
            </label>
        )}
        <StyledInput
          id={name}
          name={name}
          value={value}
          onChange={handleChange}
          onFocus={handleFocus}
          disabled={disabled}
          required={required}
          hasError={!valid && touched}
          type={props.type}
          placeholder={props.placeholder}
        />
      </div>
      {!valid && !disabled && (
        <ErrorText>{t(error.key, error.options)}</ErrorText>
      )}
    </StyledInputContainer>
  )
}

ContactFormInput.defaultProps = {
  onChange: () => {},
  validate: () => {}
}

export default ContactFormInput